module.exports = __webpack_public_path__ + "img/google-logo.b75aecaf.png";